import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UiButtonComponent} from './ui-button/ui-button.component';
import {UiDropdownComponent} from './ui-dropdown/ui-dropdown.component';
import {UiTabComponent} from './ui-tab/ui-tab.component';
import {UiBadgeComponent} from './ui-badge/ui-badge.component';
import {UiDropItemComponent} from './ui-dropdown/components/ui-drop-item/ui-drop-item.component';
import {DropTriggerDirective} from './ui-dropdown/directives/drop-trigger.directive';
import {UiCardComponent} from './ui-card/ui-card.component';
import {CardActionDirective} from './ui-card/directives/card-action.directive';
import {UiHighlightComponent} from './ui-highlight/ui-highlight.component';
import {UiAlertComponent} from './ui-alert/ui-alert.component';
import {UiLoading} from '../../directives/ui-loading.directive';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NgSelectModule} from '@ng-select/ng-select';
import {UiSwitchComponent} from './ui-switch/ui-switch.component';
import {UiIconComponent} from './ui-icon/ui-icon.component';
import {UiTableDirective} from '../../directives/ui-table.directive';
import {UiTableRowDirective} from '../../directives/ui-table-row.directive';
import {UiBalloonComponent} from './ui-balloon/ui-balloon.component';
import {UiBalloonTriggerDirective} from './ui-balloon/directives/ui-balloon-trigger.directive';
import {UiKeyComponent} from './ui-key/ui-key.component';

@NgModule({
    declarations: [
        UiButtonComponent,
        UiDropdownComponent,
        UiTabComponent,
        UiBadgeComponent,
        UiDropItemComponent,
        UiIconComponent,
        DropTriggerDirective,
        UiCardComponent,
        CardActionDirective,
        UiHighlightComponent,
        UiAlertComponent,
        UiCardComponent,
        UiLoading,
        UiSwitchComponent,
        UiTableDirective,
        UiTableRowDirective,
        UiBalloonComponent,
        UiBalloonTriggerDirective,
        UiKeyComponent
    ],
    exports: [
        UiButtonComponent,
        UiDropdownComponent,
        UiTabComponent,
        UiBadgeComponent,
        UiDropItemComponent,
        UiIconComponent,
        DropTriggerDirective,
        UiCardComponent,
        CardActionDirective,
        UiHighlightComponent,
        UiAlertComponent,
        UiCardComponent,
        UiLoading,
        UiSwitchComponent,
        UiTableDirective,
        UiTableRowDirective,
        UiBalloonComponent,
        UiBalloonTriggerDirective,
        UiKeyComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatTooltipModule,
        NgSelectModule
    ]
})
export class UiBasicModule {
}
